import { type ConsentStatus, getStatusTagColor } from '@lmc/common/types'
import { Tag } from 'antd'
import type React from 'react'
import styled from 'styled-components'

interface ConsentStatusTagProps {
  status: ConsentStatus | string
  label: string
}

const ConsentStatusTag: React.FC<ConsentStatusTagProps> = ({
  status,
  label
}) => {
  const color = getStatusTagColor(status)

  return <StyledTag color={color}>{label}</StyledTag>
}

const StyledTag = styled(Tag)`
  text-transform: capitalize;
  font-weight: normal;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

export default ConsentStatusTag
